import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_API_URL || window.location.origin;
export const socket = io(SOCKET_URL, {
  path: '/socket.io',    // adjust if you mounted Socket.IO on a custom path
  transports: ['websocket'],
  autoConnect: true,
});

socket.on("connect", () => {
  console.log("[socket] connect id=", socket.id);
});
socket.on("disconnect", (reason) => {
  console.log("[socket] disconnect reason=", reason);
});
socket.on("connect_error", (err) => {
  console.log("[socket] connect_error", err?.message, err);
});
socket.io.on("reconnect_attempt", (n) => console.log("[socket] reconnect_attempt", n));
socket.io.on("reconnect", (n) => console.log("[socket] reconnect", n));
socket.io.on("reconnect_error", (e) => console.log("[socket] reconnect_error", e));

socket.io.on('reconnect', () => {
  socket.emit('join_package_updates');
});